/** `Date` <-> the `yyyy-MM-dd` / `HH:mm` strings the native inputs use. */

export function toDateInputValue(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function toTimeInputValue(date: Date): string {
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${hours}:${minutes}`
}

const DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/
const TIME_PATTERN = /^([01]\d|2[0-3]):([0-5]\d)$/

export function parseDateInput(value: string): { year: number; month: number; day: number } | null {
  const match = DATE_PATTERN.exec(value)
  if (!match) return null
  const [, year, month, day] = match
  return { year: Number(year), month: Number(month) - 1, day: Number(day) }
}

export function parseTimeInput(value: string): { hours: number; minutes: number } | null {
  const match = TIME_PATTERN.exec(value)
  if (!match) return null
  const [, hours, minutes] = match
  return { hours: Number(hours), minutes: Number(minutes) }
}

/** Background-image shorthand; several screens set covers this way. */
export function backgroundImage(src: string | null | undefined) {
  return src ? { backgroundImage: `url(${JSON.stringify(src)})` } : undefined
}
